import { modelHooks, useGlobalModelsContext } from "contexts/GlobalModelContext";
export type ModelHooks = typeof modelHooks;

export type ModelReturnTypes = {
  [K in keyof ModelHooks]: ReturnType<ModelHooks[K]>;
};

export function useModel<M extends keyof ModelReturnTypes>(modelName: M): ModelReturnTypes[M] {
  // 从全局 Context 中获取所有模型实例
  const context = useGlobalModelsContext();

  // 获取指定模型的实例
  const model = context[modelName];

  // 如果模型不存在，则抛出错误
  if (!model) {
    throw new Error(
      `Model  not found. Please ensure it's registered in src/models/index.ts and its hook is correctly defined.`
    );
  }

  return model;
}
